import { combineReducers } from "redux"
import userDataReducer from "./userDataReducer"

const appReducer = combineReducers({
  userData: userDataReducer,
})

const rootReducer = (state: any, action: any) => {
  return appReducer(state, action)
}

export default rootReducer
export type AppRootState = ReturnType<typeof appReducer>
